/* eslint-disable no-undef */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Menu, KeyboardArrowDown } from 'emotion-icons/material'
import Link from 'gatsby-theme-leshen/src/components/Link'
import PhoneCTA from 'gatsby-theme-leshen/src/components/PhoneCTA'
import MobileNav from './MobileNav'
import * as Styled from './Header.styles'
import primaryLogo from '../../../images/primary-logo.svg'

const headerNavItems = [
  {
    title: 'Home Energy',
    subnav: [
      { title: 'Home Energy', url: '/home-energy' },
      { title: 'Residential Plans', url: '/home-energy/plans' },
    ],
  },
  {
    title: 'Commercial Energy',
    subnav: [
      {
        title: 'Commercial Energy',
        url: '/commercial-energy',
      },
      {
        title: 'LED Retrofit',
        url: '/commercial-energy/benefits-of-led-retrofits',
      },
      {
        title: 'Smart Building Controls',
        url: '/commercial-energy/smart-building-controls',
      },
      {
        title: 'Commercial Energy Rates',
        url: '/commercial-energy/commercial-energy-rates',
      },
      { title: 'Affinity Program', url: '/commercial-energy/affinity-program' },
      {
        title: 'Energy Management',
        url: '/commercial-energy/why-is-energy-management-important',
      },
      {
        title: 'HVAC Controls',
        url: '/commercial-energy/hvac-controls',
      },
      {
        title: 'Lighting Control',
        url: '/commercial-energy/lighting-control',
      },
      {
        title: 'Energy Monitoring',
        url: '/commercial-energy/what-is-energy-monitoring',
      },
      {
        title: 'Energy Analytics',
        url: '/commercial-energy/energy-analytics-benefits-and-how-it-works',
      },
      {
        title: 'Advanced Solutions',
        url: '/commercial-energy/advanced-solutions',
      }
    ],
  },
  { title: 'Locations', url: '/locations' },
  {
    title: 'Learning Center',
    subnav: [
      {
        title: 'Learning Center',
        url: '/learning-center',
      },
      {
        title: 'Green Energy',
        url: '/green-energy',
      },
      {
        title: 'Energy Deregulation',
        url: '/learning-center/deregulation',
      },
      {
        title: 'Electricity',
        url: '/learning-center/electricity',
      },
      {
        title: 'Glossary of Terms',
        url: '/learning-center/glossary-of-terms',
      },
      {
        title: 'Natural Gas',
        url: '/learning-center/natural-gas',
      },
      {
        title: 'Prices & Products',
        url: '/learning-center/prices-and-products',
      },
      {
        title: 'Energy Savings Kit',
        url: '/learning-center/energy-savings-kit'
      },
      {
        title: 'Price Volatility',
        url: '/learning-center/price-volatility',
      },
      {
        title: 'Scam Avoidance',
        url: '/learning-center/scam-avoidance',
      },
    ],
  },
  { title: 'Blog', url: '/blog' },
]

const Header = ({ dark, ...props }) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <>
      <Styled.Header role="banner" dark={dark} {...props}>
        <Styled.TopBar padTop={false} padBottom={false}>
          <div className="links">
            <Link to="/">EN</Link>
            <Link to="/es">ES</Link>
            <Link to="/customer-service">Help</Link>
            <Link to="/myaccount">My Account</Link>
          </div>
        </Styled.TopBar>
        <Styled.BottomBar padTop={false} padBottom={false}>
          <Styled.MainNav role="navigation" dark={dark}>
            <Link to="/" className="logo">
              <img src={primaryLogo} alt="JustEnergy Logo" />
            </Link>
            {headerNavItems.map(item =>
              typeof item.subnav === 'undefined' ? (
                <span key={item.title} className="primary-link">
                  <span>
                    <Link to={item.url}>{item.title}</Link>
                  </span>
                </span>
              ) : (
                <span key={item.title} className="primary-link">
                  <span>
                    {item.title} <KeyboardArrowDown size={18} />
                  </span>
                  <ul className="subnav">
                    {item.subnav.map(subitem => (
                      <li>
                        <Link to={subitem.url}>{subitem.title}</Link>
                      </li>
                    ))}
                  </ul>
                </span>
              )
            )}
          </Styled.MainNav>
          <PhoneCTA>Order</PhoneCTA>
        </Styled.BottomBar>
      </Styled.Header>

      <Styled.MobileHeader>
        <Link to="/" className="logo">
          <img src={primaryLogo} alt="JustEnergy Logo" />
        </Link>
        <Menu onClick={() => setMobileNavOpen(!isMobileNavOpen)} />
      </Styled.MobileHeader>

      <MobileNav
        headerNavItems={headerNavItems}
        isMobileNavOpen={isMobileNavOpen}
      />
    </>
  )
}

Header.defaultProps = {
  topBarNavItems: {},
  dark: false,
}

Header.propTypes = {
  dark: PropTypes.bool,
  headerNavItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  topBarNavItems: PropTypes.arrayOf(PropTypes.object),
}

export default Header
